export enum Roles {
  Administrator = 'Administrator',
  Planner = 'Planner',
  PortalUser = 'PortalUser',
}
